var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29664",
    "data-name": "Path 29664",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rule",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29663",
    "data-name": "Path 29663",
    d: "M15.83,10.29,13.71,8.17a1,1,0,0,1,1.41-1.41l1.41,1.41,3.54-3.54a1,1,0,0,1,1.41,1.41l-4.24,4.24a.987.987,0,0,1-1.41.01ZM10,7H3A1,1,0,1,0,3,9h7a1,1,0,1,0,0-2Zm10.29,5.71a1,1,0,0,0-1.41,0L17,14.59l-1.88-1.88a1,1,0,0,0-1.41,1.41L15.59,16l-1.88,1.88a1,1,0,0,0,1.41,1.41L17,17.41l1.88,1.88a1,1,0,0,0,1.41-1.41L18.41,16l1.88-1.88a1,1,0,0,0,0-1.41ZM10,15H3a1,1,0,0,0,0,2h7a1,1,0,0,0,0-2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRule);
export default __webpack_public_path__ + "static/media/rule.bc2d467daddc8aaef2a31ff8c678ce8c.svg";
export { ForwardRef as ReactComponent };